<template>
  <tr class="clinic-payment" style="vertical-align: middle">
    <td class="clinic-payment__date">{{ pretty_date }}</td>
    <td v-if="enable_payments_v2" class="clinic-payment__type">
      {{ pretty_acc_entry }}
    </td>
    <td class="clinic-payment__type">{{ pretty_type }}</td>
    <td class="clinic-payment__customer">
      <a class="btn-link" target="_blank" :href="customer_link">
        {{ customer ? customer.full_name : "PACIENTE BORRADO" }}</a>
      <i v-if="customer.exclude_auto_invoice" class="fa fa-exclamation-circle" data-toggle="tooltip"
        title="Paciente excluido de la Facturación Automática, examinar su Ficha para más información"></i>
    </td>
    <td v-if="clinics && clinics.length > 1" class="clinic-payment__clinic">
      {{ clinic_name }}
    </td>
    <td v-if="invoices_enabled" class="clinic-payment__invoice">
      <a v-if="payment.invoice" class="btn-link" target="_blank" :href="invoice_link">{{ invoice_code }}</a>
      <button @click="emitInvoice" v-else class="btn btn-wabident-round">
        Facturar
      </button>
    </td>
    <td class="clinic-payment__amount text-right">
      {{ pretty_amount }}
      <button @click="updatePayment" class="btn btn-wabident-round ml-2" style="font-size: 10px; padding: 5px 15px">
        <i class="fa fa-edit"></i>
      </button>
    </td>
  </tr>
</template>

<script>

export default {
  props: {
    payment: { required: true },
    clinics: { default: null },
    invoices_enabled: { default: false },
  },
  computed: {
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    customer_link() {
      if (this.customer) {
        return `/customer/${this.customer.id}/edit`;
      }
      return "";
    },
    customer() {
      return this.payment.customer;
    },
    pretty_date() {
      return moment(this.payment.created_at).format("DD/MM/YYYY");
    },
    pretty_acc_entry() {
      return (
        {
          deposit: "Depósito",
          assignment: "Asignación",
        }[this.payment.accounting_entry] || "N/D"
      );
    },
    pretty_type() {
      return (
        {
          cash: "Efectivo",
          credit_card: "Tarjeta",
          transfer: "Transferencia",
          mobile: "Bizum/Móvil",
          direct_debit: "Financiación",
          expense_interests: "Intereses Fin.",
          fragmented: "Frakmenta",
          tpv: "TPV",
          other: "Otros",
          sepa_transfer: "Recibo (SEPA)",
        }[this.payment.type] || "Otros"
      );
    },
    pretty_amount() {
      return WabiDent.fmtMoney(this.payment.amount, 0);
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.payment.clinic_id] || "";
    },
    invoice_code() {
      if (!this.payment.invoice) return "";
      return this.payment.invoice.code;
    },
    invoice_link() {
      if (!this.payment.invoice) return "";
      return `/invoice/${this.payment.invoice.id}/pdf`;
    },
    ...mapGetters(["clinic"]),
  },
  methods: {
    emitInvoice() {
      this.$emit("invoice", this.payment);
    },
    updatePayment() {
      this.$emit("payment", this.payment);
    },
  },
};
</script>

<style lang="scss">
.clinic-payment {
  td {
    vertical-align: middle;
  }
}
</style>
